import { Injectable } from '@angular/core';
const SMALL_WIDTH_BREAKPOINT = 768;
const TABLET_WIDTH_BREAKPOINT = 1024;
@Injectable({
    providedIn: 'root'
})
export class ScreenSizeService {
    private mediaMatcher: MediaQueryList =
        matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
    private tabletMediaMatcher: MediaQueryList =
        matchMedia(`(max-width: ${TABLET_WIDTH_BREAKPOINT}px)`);

    constructor(
    ) { }
    isScreenSmall(): boolean {
        return this.mediaMatcher.matches;
    }

    isScreenTabletOrSmaller(): boolean {
        return this.tabletMediaMatcher.matches;
    }
}
